var EXPAND_COLUMN = {};
var INTERNAL_HOOKS = 'rc-table-internal-hook';
export { EXPAND_COLUMN, INTERNAL_HOOKS };
//# sourceMappingURL=constant.js.map
